module.exports = __webpack_public_path__ + "prod/20260929161836/img/logo_v2.a0a47605.png";